import React from 'react';

const AnimatedBackground = () => {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
      {/* Floating geometric shapes */}
      <div className="absolute top-20 left-10 w-32 h-32 border border-gray-200 dark:border-gray-700 rounded-full animate-float opacity-20" />
      <div className="absolute top-40 right-20 w-24 h-24 border border-gray-200 dark:border-gray-700 rotate-45 animate-float-delayed opacity-20" />
      <div className="absolute bottom-40 left-1/4 w-16 h-16 border border-gray-200 dark:border-gray-700 rounded-lg animate-float-slow opacity-20" />
      <div className="absolute top-1/3 right-1/4 w-20 h-20 border border-gray-200 dark:border-gray-700 rounded-full animate-float opacity-15" />
      <div className="absolute bottom-20 right-10 w-28 h-28 border border-gray-200 dark:border-gray-700 rotate-12 animate-float-delayed opacity-20" />
      
      {/* Gradient orbs */}
      <div className="absolute top-1/4 left-1/3 w-96 h-96 bg-gradient-to-br from-gray-100 to-transparent dark:from-gray-800 dark:to-transparent rounded-full blur-3xl animate-morph opacity-40" />
      <div className="absolute bottom-1/4 right-1/3 w-80 h-80 bg-gradient-to-tl from-gray-100 to-transparent dark:from-gray-800 dark:to-transparent rounded-full blur-3xl animate-morph-reverse opacity-30" />
      
      {/* Moving dots */}
      {[...Array(15)].map((_, i) => (
        <div
          key={i}
          className="absolute w-1 h-1 bg-gray-300 dark:bg-gray-600 rounded-full animate-float"
          style={{
            left: `${10 + (i * 6)}%`,
            top: `${15 + (i % 5) * 20}%`,
            animationDelay: `${i * 0.3}s`,
            animationDuration: `${6 + (i % 3) * 2}s`
          }}
        />
      ))}
      
      {/* Animated lines */}
      <svg className="absolute inset-0 w-full h-full opacity-5 dark:opacity-10">
        <line x1="0" y1="30%" x2="100%" y2="30%" stroke="currentColor" strokeWidth="0.5" className="animate-pulse-slow" />
        <line x1="0" y1="60%" x2="100%" y2="60%" stroke="currentColor" strokeWidth="0.5" className="animate-pulse-slow" style={{ animationDelay: '1s' }} />
        <line x1="20%" y1="0" x2="20%" y2="100%" stroke="currentColor" strokeWidth="0.5" className="animate-pulse-slow" style={{ animationDelay: '0.5s' }} />
        <line x1="80%" y1="0" x2="80%" y2="100%" stroke="currentColor" strokeWidth="0.5" className="animate-pulse-slow" style={{ animationDelay: '1.5s' }} />
      </svg>
    </div>
  );
};

export default AnimatedBackground;
